import { type MeterState } from './meter-types'
import { createReducer } from '@reduxjs/toolkit'
import {
  FetchMeterHistoryValuesAction,
  FetchMeterHistoryValuesSuccessAction,
  SetMeterInEditorAction
} from './meter-actions'
import { MeterUtils } from './meter-utils'

export const initialMeterState: MeterState = {
  meterInEditor: null,
  history: {
    fetchingHistoryGraphData: false,
    historyGraphData: {
      water: {
        labels: [],
        datasets: []
      },
      temperature: {
        labels: [],
        datasets: []
      }
    }
  }
}

export const meterReducer = createReducer(initialMeterState, builder => {
  builder.addCase(SetMeterInEditorAction, (state, action) => {
    state.meterInEditor = action.payload
  }).addCase(FetchMeterHistoryValuesAction, (state, _action) => {
    state.history.fetchingHistoryGraphData = true
    state.history.historyGraphData = {
      ...initialMeterState.history.historyGraphData
    }
  }).addCase(FetchMeterHistoryValuesSuccessAction, (state, action) => {
    state.history.fetchingHistoryGraphData = false
    state.history.historyGraphData = {
      water: MeterUtils.groupWaterHistoryGraphData(action.payload.data, action.payload.scale),
      temperature: MeterUtils.groupTemperatureHistoryGraphData(action.payload.data)
    }
  })
}
)
